import React from 'react';
import { LuArrowLeft, LuSettings, LuUserPlus, LuPlus, LuGitBranch } from "react-icons/lu";

const InterfaceHeader = ({ 
  title, 
  onBackClick, 
  onSettingsClick, 
  onInviteClick, 
  onNewClick,
  newButtonText = "New Item"
}) => {
  return (
    <div className="w-full h-fit border-b border-[#ffffff10] pb-4 flex justify-between">
      <div className="flex items-center space-x-4">
        <button
          onClick={onBackClick}
          className="p-2 hover:bg-[#ffffff10] rounded-lg transition-colors"
        >
          <LuArrowLeft className="w-5 h-5" />
        </button>
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-purple-400/20 rounded-lg">
            <LuGitBranch className="w-6 h-6 text-purple-400" />
          </div>
          <div>
            <div className="text-3xl font-medium">{title}</div>
          </div>
        </div>
      </div>
      <div className="flex space-x-3">
        <div
          className="py-1.5 px-2.5 h-fit aspect-square flex items-center justify-center border border-[#ffffff10] rounded-lg hover:bg-[#ffffff10] transition hover:border-[#ffffff15] cursor-pointer active:scale-95 transform duration-150 ease-out"
          onClick={onSettingsClick}
        >
          <LuSettings />
        </div>
        <div
          className="px-4 py-1.5 h-fit border border-[#ffffff10] space-x-2 rounded-lg flex items-center justify-center hover:bg-[#ffffff10] transition hover:border-[#ffffff15] cursor-pointer active:scale-95 transform duration-150 ease-out"
          onClick={onInviteClick}
        >
          <LuUserPlus />
          <div>Invite</div>
        </div>
        <div
          className="px-4 py-1.5 h-fit border border-[#ffffff10] space-x-2 rounded-lg flex items-center justify-center hover:bg-[#ffffff10] transition hover:border-[#ffffff15] cursor-pointer active:scale-95 transform duration-150 ease-out"
          onClick={onNewClick}
        >
          <LuPlus />
          <div>{newButtonText}</div>
        </div>
      </div>
    </div>
  );
};

export default InterfaceHeader;